<div id="layout" class="theme-cyan">
  <app-event-leftmenu></app-event-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="avatar sm">
                  <a [routerLink]="['/events']" href="javascript:void(0)" title="" class="link"><i
                      class="zmdi zmdi-arrow-left zmdi-hc-lg"></i></a>
                </div>
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h6 class="fw-bold text-truncate mb-0 me-auto">Add New Events</h6>
                  </div>
                  <div class="text-truncate">Last Update your profile: 29 Aug 2020</div>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
              </ul>
            </div>

          </div>

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <form class="row">
            <div class="col-lg-12">
              <div class="form-group">
                <div class="input-group">
                  <input type="text" class="form-control form-control-lg" placeholder="Enter event name">
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-group">
                <select class="form-control form-control-lg custom-select" data-bs-toggle="select City">
                  <option value="0">Select city</option>
                  <option value="1">NewYork</option>
                  <option value="2">London</option>
                  <option value="3">Ottawa</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-group">
                <select class="form-control form-control-lg custom-select" data-bs-toggle="select City">
                  <option value="0">Select sponsor</option>
                  <option value="1">Jane Hunt</option>
                  <option value="2">Daniel Kristeen</option>
                  <option value="3">Jason Porter</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-group">
                <div class="input-group">
                  <input type="text" class="form-control form-control-lg" placeholder="Enter start date" bsDatepicker>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-group">
                <div class="input-group">
                  <input type="text" class="form-control form-control-lg" placeholder="Enter end date" bsDatepicker>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-group">
                <div class="input-group">
                  <input type="text" class="form-control form-control-lg" placeholder="Enter total tickets">
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-group">
                <div class="input-group">
                  <input type="text" class="form-control form-control-lg" placeholder="Tickets rate">
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label>Select Event Photo</label>
                <input type="file" class="form-control-file">
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <div class="input-group">
                  <textarea rows="4" class="form-control" placeholder="Enter Events Bio"></textarea>
                </div>
              </div>
            </div>
            <div class="col-12">
              <button type="button" class="btn btn-primary">Create</button>
              <a [routerLink]="['/events']" href="javascript:void(0)" title="" class="btn btn-link">Cancel</a>
            </div>
          </form>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
